import Baa from './Baa'

export default Baa



// WEBPACK FOOTER //
// ./src/legacy/pages/Baa/index.js